/* eslint-disable */
import React, { FC, ReactElement } from 'react';
import withBrands from '../../hoc/withBrands';
import withLocalization from '../../hoc/withLocalization';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import './PaymentErrorModal.scss';
import intlModalCloseLogo from '../../../features/siteTheme/Brands/tmvcs/logo/intlModalCloseLogo.svg';
import phoneLogo from '../../../features/siteTheme/Brands/tmvcs/logo/intl-phoneLogo.svg';
import ParseHtml from '../../common/ParseHtml';
import isAsia from '../../../util/isAsia';
import '../CyberSourceErrorModal/CyberSourceErrorModal.scss';
import { getSafeTelHref } from '../../../util/CommonLogic';
interface ImgModalProps {
  localize?: any;
  image?: string;
  closeModal: () => void;
  msg?: string;
  phoneNo?: any;
  localizeImages?: any;
  prospectDetails?: any;
}

const PaymentErrorModal: FC<any> = (props: ImgModalProps): ReactElement => {
  const { closeModal, localize, localizeImages, phoneNo, prospectDetails } = props;
  const modalErrStatus = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalErrStatus);
  const defaultPhNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');
  const defaultChatLinkText = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-chat-link')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-chat-link');
  const whatsAppImgData = localizeImages('preview-sales-engine.static-content.images.whatsapp-logo', 0, '5:1');
  const whatsAppPath = whatsAppImgData?.path || '';
  const callCenterCode = prospectDetails?.callCenterCode || '';
  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.errorPhone`;
  const callCenterDefault = `${localize(jahiaCallcenter)}`;
  //const phoneWithDialcode = phoneNo || callCenterDefault;
  const phoneWithDialcode = callCenterDefault;
  const defaultErrorPhone = phoneWithDialcode || defaultPhNo;
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;
  const chatLinkText: any = localize(jahiaKey) || defaultChatLinkText;
  const errCode = modalErrStatus?.toUpperCase() || '';
  const handleKeyDown = () => {};
  const getErrMsg = (): string => {
    switch (errCode) {
      case 'CREDIT_CARD_DECLINED_GENERIC':
        return localize(
          `preview-sales-engine.static-content.copy.Labels.error-message.pbeo.credit-card-declined-generic`,
        );
      case 'CREDIT_CARD_INVALID_DATA':
        return localize(`preview-sales-engine.static-content.copy.Labels.error-message.pbeo.credit-card-invalid-data`);
      case 'CREDIT_CARD_INVALID_ADDR':
        return localize(`preview-sales-engine.static-content.copy.Labels.error-message.pbeo.credit-card-invalid-addr`);
      case 'CREDIT_CARD_TIMEOUT':
        return localize(`preview-sales-engine.static-content.copy.Labels.error-message.credit-card-timeout`);
      case 'CREDIT_CARD_DECLINED':
        return localize(`preview-sales-engine.static-content.copy.Labels.error-message.pbeo.credit-card-declined`);
      case 'CREDIT_CARD_DECLINED_SYSTEM':
        return localize(
          `preview-sales-engine.static-content.copy.Labels.error-message.pbeo.credit-card-declined-system`,
        );
      default:
        return localize(
          `preview-sales-engine.static-content.copy.Labels.error-message.pbeo.credit-card-declined-generic`,
        );
    }
  };
  const handleClickChatLink = (e: any) => {
    e.preventDefault();
    //window.location.href = chatLinkText;
    window.open(chatLinkText, '_blank');
    window.dataLayer.push({
      event: 'whatsapp',
    });
  };

  return (
    <div className="modal-Payment-err">
      <div className="modal-content-PaymentErr">
        <div className="paymentErr-container">
          <div className="payment-err-head-container">
            <div className="paymentErrModal-title-container">
              <span className="PaymentErr-title-text">
                {localize(
                  `preview-sales-engine.static-content.copy.Labels.error-message.credit-card-declined-modal-title`,
                )}
              </span>
            </div>
            <div className="payment-err-close-icon-wrapper">
              <button
                className="cyberSourceErr-modal-close-btn"
                // src={intlModalCloseLogo}
                // type="image"
                onClick={closeModal}
                aria-label="close"
              >
                <img src={intlModalCloseLogo} alt="close" className="close-icon" />
              </button>
            </div>
          </div>

          <div className="paymentErr-content-section">
            <div className="paymentErr-desc-container">
              <div className="paymentErr-desc-text">
                <ParseHtml htmlInput={getErrMsg()} />
                {/*<ParseHtml
                  htmlInput={localize('preview-sales-engine.static-content.copy.prospects.contactvacationspecialist', [
                    1234,
                    1234,
                  ])}
                />*/}
              </div>
              <div className="payment-err-phone-container">
                <div className="payment-err-phone-link">
                  <a className="err-phone-anchor" href={encodeURI(getSafeTelHref(defaultErrorPhone))}>
                    <img
                      onKeyDown={handleKeyDown}
                      tabIndex={0}
                      src={phoneLogo}
                      alt="Call Now"
                      className="cybersource-payment-err-phone-icon"
                    />
                    <span
                      aria-label={'phone-err-call'}
                      onKeyDown={handleKeyDown}
                      tabIndex={0}
                      className="cybersource-payment-err-phone"
                    >{`+${defaultErrorPhone}`}</span>
                  </a>
                  {chatLinkText && (
                    <>
                      <div className="header-pipe">|</div>
                      <a href={'#'} onClick={handleClickChatLink}>
                        <img className="err-paymentphone-img" src={whatsAppPath} alt="whatsapp" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="paymentModalErr-section">
            <div
              className="paymentErr-close-wrapper"
              onClick={closeModal}
              arial-label={'see-detail'}
              role="button"
              tabIndex={0}
              onKeyDown={handleKeyDown}
            >
              <div className="payErr-close-text-span">
                {localize(`preview-sales-engine.static-content.copy.pbeo.ineligible-state-thank-you-modal-cta`)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(withLocalization(withBrands(PaymentErrorModal)));
